/* Removing the base tag so routing works correctly.
   Base tag is used to load the app directly from the cdn,
   so we don't have to have the same url structure as the enduser in the s3 bucket*/
const base = document.querySelector('base');
if (base) {
    base.parentElement.removeChild(base);
}

import './index';
